import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-counties',
  templateUrl: './counties.component.html',
  styleUrls: ['./counties.component.scss']
})
export class CountiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
